<div class="header">
    {{ title }}
</div>
<div class="body">
    <textarea
        #textarea
        class="message-input"
        placeholder="Enter your message..."
        [ngModel]="message$ | async"
        (ngModelChange)="updateMessage($event)"
        rows="5"
        maxlength="500">
    </textarea>
    <div class="char-count">{{ (message$ | async)?.length || 0 }}/500</div>
</div>
<div class="footer">
    <button type="button" class="button cancel" (click)="cancelHandler()">Cancel</button>
    <button type="button" class="button ok" (click)="submitHandler()" [disabled]="!(message$ | async)?.trim()">Send</button>
</div>
